import React, { Component } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import styled from "styled-components";
import { Helmet } from "react-helmet";

import { getVideosPage } from "../configureStore";
import { fetchVideosPage } from "../configureStore/videosPage";
import { getHelmet } from "../utilities";
import { FromTopPage, Banner, GridWrapper } from "../theme";
import NotFound from "../components/NotFound";
import Error from "../components/Error";
import PageLoader from "../components/loader/PageLoader";
import ContentList from "../components/content/ContentList";
import Pagination from "../components/Pagination";
import JoinUs from "../components/JoinUs";

const Container = styled(FromTopPage)`
  header {
    margin-bottom: 60px;

    @media (max-width: 767px) {
      margin-bottom: 30px;
    }
  }
`;

class Videos extends Component {
  static fetchInitialData({ page }) {
    return [fetchVideosPage(page)];
  }

  componentDidMount() {
    this.fetchContent();
  }

  componentDidUpdate() {
    this.fetchContent();
  }

  fetchContent() {
    const { videoList, dispatch, match } = this.props;
    if (!videoList.isFetching && !videoList.error && !videoList.videos.length) {
      dispatch(fetchVideosPage(match.params.page));
    }
  }

  render() {
    const videoList = this.props.videoList;

    if (!videoList.nbrPages && videoList.error) {
      if (videoList.error === "404") {
        return <NotFound />;
      }

      return <Error message={videoList.error} />;
    }

    if (!videoList.nbrPages) {
      return <PageLoader />;
    }

    return (
      <Container>
        <Helmet>
          {getHelmet(
            "Les émissions",
            `Retrouvez toutes les émissions du Média.`,
            this.props.location.pathname
          )}
        </Helmet>
        <Banner>
          <GridWrapper>
            <div>
              <h1>Toutes les émissions</h1>
              <p>Découvrez l'ensemble de nos émissions</p>
            </div>
          </GridWrapper>
        </Banner>
        <Pagination nbrPages={videoList.nbrPages} />
        <ContentList
          contentList={{ ...videoList, content: videoList.videos }}
        />
        <Pagination nbrPages={videoList.nbrPages} />
        <JoinUs />
      </Container>
    );
  }
}

Videos.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      page: PropTypes.string,
    }).isRequired,
  }).isRequired,
  location: PropTypes.shape({
    pathname: PropTypes.string.isRequired,
  }).isRequired,
  dispatch: PropTypes.func.isRequired,
  videoList: PropTypes.shape({
    isFetching: PropTypes.bool.isRequired,
    error: PropTypes.string,
    nbrPages: PropTypes.number,
    videos: PropTypes.array.isRequired,
  }).isRequired,
};

export default connect((state, ownProps) => ({
  videoList: getVideosPage(state, ownProps.match.params.page),
}))(Videos);
